const customerUpdateMeQuery = require('../../queries/user/customerUpdateMeQuery');
const { clientMutate } = require('../queries');
const handleCtApiError = require('../handleCtApiError');

const deleteShippingAddress = async (context, currentUser, address) => {
  const actions = [];
  if (currentUser.shippingAddressIds?.includes(address.id)) {
    actions.push({
      removeShippingAddressId: { id: address.id },
    });
  }

  if (currentUser.defaultShippingAddressId === address.id) {
    actions.push({
      setDefaultShippingAddress: { addressId: null },
    });
  }

  actions.push({
    removeAddress: {
      addressId: address.id,
    },
  });

  const options = {
    mutation: customerUpdateMeQuery,
    variables: {
      version: currentUser.version,
      actions,
    },
    fetchPolicy: 'no-cache',
  };

  try {
    const updateResponse = await clientMutate(context, options);

    return updateResponse;
  } catch (error) {
    throw handleCtApiError(error);
  }
};

module.exports = deleteShippingAddress;
